import { erpAxios } from '.';

const getSegmenti = async () => {
  const { data } = await erpAxios.get('/segmenti');
  return data;
};

export default getSegmenti;